import { post } from '@/utils';

/** 文档解析结果（POST /v1/document/extract_text 返回 data） */
export interface DocumentExtractResult {
  /** 文档格式：doc / pdf 等 */
  format: string;
  /** 从文档中提取出的正文文字 */
  text: string;
}

/**
 * 文档解析服务 —— 对接《接口文档》POST /v1/document/extract_text。
 * baseURL 已含 /v1，故路径不带 /v1 前缀；后端返回的 msg 字段由 request 响应拦截器统一兼容为 message。
 */
class DocumentService {
  /** 提取文档正文文字（word / pdf），仅解析文字内容 */
  async extractText(file: File): Promise<DocumentExtractResult> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const res = await post<DocumentExtractResult>('/document/extract_text', formData, {
      timeout: 120000, // 大文件解析较慢，放宽超时
    });
    return res.data;
  }
}

export default new DocumentService();
